import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

export interface IProps{
  defaultChecked:boolean;
  onChange;
  label;
  }

  export default class MIPACheckBox extends React.Component<IProps,{}>{
  
    constructor(props: IProps) {
      
      super(props);  
        
    }
    public render() {
     
      return (        
         
          <React.Fragment>
              <Checkbox
          
              label={this.props.label}
              defaultChecked={this.props.defaultChecked}
              onChange={(ev: React.FormEvent<HTMLElement>, isChecked: boolean) => {
                this.setState({changed:true});
                this.props.onChange(ev,isChecked);
                
              }}
          />
                          
          </React.Fragment>
        
      );
    }
    
  
  }
  
  